import { VIEW_INVITATION_CLICKED } from '../actions/actionTypes';

const initialState = {
  invitationVisible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VIEW_INVITATION_CLICKED:
      return {
        ...state,
        invitationVisible: !state.invitationVisible,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/invitation.js